var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8042 4.50552L11.0541 7.95826C10.6589 8.32224 10 8.05238 10 7.51525V5.68806C6.23503 5.71269 4.64672 6.5796 5.70898 10.0388C5.82573 10.419 5.37445 10.7134 5.05779 10.4788C4.04302 9.72728 3.125 8.28974 3.125 6.83869C3.125 3.18404 6.18747 2.45881 10 2.43819V0.609685C10 0.0720643 10.6593 -0.196924 11.0541 0.16667L14.8042 3.61949C15.0652 3.85976 15.0654 4.26504 14.8042 4.50552ZM10 9.6263V11.375H1.66667V3.25H2.9926C3.03469 3.24998 3.07633 3.24166 3.11503 3.22554C3.15373 3.20943 3.18869 3.18586 3.21781 3.15624C3.60721 2.76096 4.05732 2.44809 4.5463 2.19962C4.83615 2.05233 4.72875 1.62501 4.4019 1.62501H1.25C0.559635 1.62501 0 2.17065 0 2.84375V11.7812C0 12.4544 0.559635 13 1.25 13H10.4167C11.107 13 11.6667 12.4544 11.6667 11.7812V9.52641C11.6667 9.31597 11.4532 9.16927 11.2497 9.23945C10.9644 9.33782 10.6589 9.36725 10.3594 9.32519C10.1701 9.29863 10 9.4398 10 9.6263Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.467734ebc97eb478430f3c598841cca2.svg";
export { ForwardRef as ReactComponent };